import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

Vue.mixin({
	computed: Vuex.mapGetters([
		'store_UserInfo', 'store_AsItem', 'store_AaId', 'store_AsId', 'store_AsName', 'store_AsLists', 'store_PeriodSection', "store_ShowPeriod", "store_CustId"
		, "store_isPro", "store_permission"]),
	methods: Vuex.mapActions(["$setPermission", "$setIsPro", "$setUserInfo", "$setAsItem", "$setAaId", "$setAsId", "$setAsName", "$setAsLists", "$setPeriodSection", "$setShowPeriod", "$setCustId"])
});

export default new Vuex.Store({
	state: {
		UserInfo: {
			userName: '',
			nickName: '',
			userSn: 0,
			phone: null,
		},
		AsItem: {},
		AaId: 0,
		AsId: 0,
		AsName: '',
		AsLists: [],
		PeriodSection: [],
		ShowPeriod: false,
		CustId: 0,
		isPro: false,//是否为记账专业版
		permission: null,//专业版权限2、免费版权限-1、业财权限3

	},
	getters: {
		store_UserInfo(state) {
			return {
				...state.UserInfo,
				headPortrait: state.UserInfo.headPortrait + '&v=' + Math.random()
			}
		},
		store_AsItem(state) {
			return state.AsItem
		},
		store_AsId(state) {
			return state.AsId
		},
		store_AaId(state) {
			return state.AaId
		},
		store_AsName(state) {
			return state.AsName
		},
		store_AsLists(state) {
			return state.AsLists
		},
		store_PeriodSection(state) {
			return state.PeriodSection
		},
		store_ShowPeriod(state) {
			return state.ShowPeriod
		},
		store_CustId(state) {
			return state.CustId
		},
		store_isPro(state) {
			return state.isPro
		},
		store_permission(state) {
			return state.permission
		}

	},
	mutations: {
		$setCustId(state, values) {
			state.CustId = values
		},
		$setUserInfo(state, values) {
			state.UserInfo = {
				...values
			}
		},
		$setAsItem(state, values) {
			state.AsItem = values
		},
		$setAsId(state, values) {
			state.AsId = values
		},
		$setAaId(state, values) {
			state.AaId = values
		},
		$setAsName(state, values) {
			state.AsName = values
		},
		$setAsLists(state, values) {
			state.AsLists = values
		},
		$setPeriodSection(state, values) {
			state.PeriodSection = values
		},
		$setShowPeriod(state, values) {
			state.ShowPeriod = values
		},
		//是否为记账专业版
		$setIsPro(state, values) {
			state.isPro = values;
		},
		$setPermission(state, values) {
			state.permission = values;
		},
		// //权限类型:专业版、免费版、业财
		// $setType(state,values){
		// 	state.type = values;
		// }
	},
	actions: {
		$setCustId(context, values) {
			context.commit('$setCustId', values)
		},
		$setUserInfo(context, values) {
			context.commit('$setUserInfo', values);
		},
		$setAsItem(context, values) {
			context.commit('$setAsItem', values);
		},
		$setAsId(context, values) {
			context.commit('$setAsId', values);
		},
		$setAaId(context, values) {
			context.commit('$setAaId', values);
		},
		$setAsName(context, values) {
			context.commit('$setAsName', values);
		},
		$setAsLists(context, values) {
			context.commit('$setAsLists', values)
		},
		$setPeriodSection(context, values) {
			context.commit('$setPeriodSection', values)
		},
		$setShowPeriod(context, values) {
			context.commit('$setShowPeriod', values)
		},
		$setIsPro(context, values) {
			context.commit('$setIsPro', values)
		},
		$setPermission(context, values) {
			context.commit('$setPermission', values)
		}
	},
	plugins: [
		createPersistedState({
			storage: window.sessionStorage,
		}),
	]
})
